export function useFormLayout(size, layout)
{
    if(layout === "horizontal") {
        return { 
            wrapperCol: { 
                span: 14, 
                offset: 4 
            },
            hideRequiredMark: true,
            colon: false,
            size: size
        };
    }
    
    return { 
        labelCol: { 
            span: 24 
        }, 
        wrapperCol: { 
            span: 24 
        },
        hideRequiredMark: true,
        colon: false,
        size: size
    };
}